import { render } from "./TopoAplicacao.vue?vue&type=template&id=99773a00"
import script from "./TopoAplicacao.vue?vue&type=script&lang=js"
export * from "./TopoAplicacao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__